import { useState, useRef, useEffect } from "react";
import "./report.scss";
import FilterPanel from "./FilterPanel";
import DotsIcon from "../icons/DotsIcon";
import PrintIcon from "../icons/PrintIcon";
import ExcelIcon from "../icons/ExcelIcon";
import BarIcon from "../icons/BarIcon";
import FilterIcon from "../icons/FilterIcon";
import PdfIcon from "../icons/PdfIcon";
import { DateRangePicker } from "./CalederComponent";
import TbaleIcon from "../icons/TbaleIcon";
import { useTranslation } from "react-i18next";

function Tooltip({ text, children }) {
   const { t } = useTranslation()
  const [show, setShow] = useState(false);
  return (
    <div
      style={{ position: "relative", display: "inline-flex" }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {children}
      {show && (
        <div
          style={{
            position: "absolute",
            bottom: "calc(100% + 6px)",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#1e293b",
            color: "#fff",
            fontSize: 11,
            padding: "4px 8px",
            borderRadius: 6,
            whiteSpace: "nowrap",
            pointerEvents: "none",
            zIndex: 300,
          }}
        >
          {t(text)}
        </div>
      )}
    </div>
  );
}

const SubHeader = ({
  filters,
  showCharts = false,
  setShowCharts=()=>{},
  onFilterApply = () => {},
  onDateChange = () => {},
  onPrint = () => window.print(),
  onPdf = () => alert("Export PDF"),
  onExcel = () => alert("Export Excel"),
}) => {
   const { t } = useTranslation()
  const [showFilter, setShowFilter] = useState(false);
  const [showDownloads, setShowDownloads] = useState(false);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState({});

  const fmtDate = (d) => {
    if (!d) return null
    const date = new Date(d)
    const y = date.getFullYear()
    const m = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${y}-${m}-${day}`
  }

  const getEffectiveEndDate = (start, end) => {
    if (end) return end;
    return start ? new Date() : null;
  };

  const filterRef = useRef();
  const downloadRef = useRef();

  useEffect(() => {
    const h = (e) => {
    
      if (downloadRef.current && !downloadRef.current.contains(e.target))
        setShowDownloads(false);
       if (filterRef.current && !filterRef.current.contains(e.target))
        setShowFilter(false);
    };
    
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);


  const activeFilterCount = Object.values(selectedFilters).flat().length;
  return (
    <div className="toolbar-wrapper">
      <div className="toolbar-left">
        {/* Search */}
        <div className="search-wrapper">
          <svg
            width="14"
            height="14"
            fill="none"
            stroke="#aaa"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            <circle cx="11" cy="11" r="7" />
            <path d="M17 17l4 4" strokeLinecap="round" />
          </svg>
          <input
            className="search-input"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                const effectiveEndDate = getEffectiveEndDate(startDate, endDate);
                onFilterApply({
                  ...selectedFilters,
                  start_date: fmtDate(startDate),
                  end_date: fmtDate(effectiveEndDate),
                  search
                });
              }
            }}
            placeholder={t("Search")}
          />
        </div>

        {/* Filter */}
        <div ref={filterRef} style={{ position: "relative" }}>
          <button
            className={`filter-btn ${
              activeFilterCount ? "filter-active" : "filter-inactive"
            }`}
            onClick={() => setShowFilter((o) => !o)}
          >
            <FilterIcon />
            {/* {activeFilterCount > 0 && (
              <span className="filter-count">{activeFilterCount}</span>
            )} */}
          </button>

          {showFilter && (
            <FilterPanel
              filters={filters}
              selected={selectedFilters}
              onChange={setSelectedFilters}
              onApply={(localFilters) => {
                setSelectedFilters(localFilters);
                const effectiveEndDate = getEffectiveEndDate(startDate, endDate);
                onFilterApply({
                  ...localFilters,
                  start_date: fmtDate(startDate),
                  end_date: fmtDate(effectiveEndDate),
                  search
                })
                setShowFilter(false)
              }}
              onClose={() => setShowFilter(false)}
            />
          )}
        </div>
      </div>

      {/* Right: Date range + Bar icon + Download menu */}
      <div className="toolbar-right">
        {/* Date Range Picker */}
     <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          onChange={(s, e) => {
            const effectiveEndDate = getEffectiveEndDate(s, e);
            setStartDate(s);
            setEndDate(effectiveEndDate);
            onDateChange(s, effectiveEndDate);
            onFilterApply({ ...selectedFilters, start_date: fmtDate(s), end_date: fmtDate(effectiveEndDate), search })
          }}
        />

        {/* Dashboard / Bar icon — only when parent enables chart mode */}
        {typeof setShowCharts === "function" && (
          <Tooltip text={showCharts ? "Table" : "Dashboard"}>
            <button
              type="button"
              className="icon-btn"
              onClick={() => setShowCharts(!showCharts)}
            >
              {!showCharts ? <BarIcon /> : <TbaleIcon />}
            </button>
          </Tooltip>
        )}

        {/* Download menu */}
        <div ref={downloadRef} className="more-actions-wrapper">
          <button
            onClick={() => setShowDownloads((o) => !o)}
            className="icon-btn"
          >
            <DotsIcon />
          </button>

          {showDownloads && (
            <div className="dropdown-box download-menu">
              {[
                { icon: <PrintIcon color="#767676" />, action: onPrint },
                { icon: <PdfIcon />, action: onPdf },
                { icon: <ExcelIcon />, action: onExcel },
              ].map(({ icon, action }) => (
                <button
                  onClick={() => {
                    action();
                    setShowDownloads(false);
                  }}
                  className="download-btn"
                >
                  {icon}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
